import request from '@/utils/request'

export function getInviteInfo() {
  return request.get('/invite/info')
}

export function getInvitePromo() {
  return request.get('/invite/promo')
}

export function bindInviteCode(inviteCode) {
  return request.post('/invite/bind', { inviteCode })
}
